var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "#5890ff",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3363_10827)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 11.0653C22.5 4.99014 17.5751 0.0652733 11.5 0.0652733C5.42486 0.0652733 0.5 4.99014 0.5 11.0653C0.5 16.5557 4.52254 21.1064 9.78125 21.9316V14.245H6.98828V11.0653H9.78125V8.64184C9.78125 5.88496 11.4235 4.36215 13.9361 4.36215C15.1396 4.36215 16.3984 4.57699 16.3984 4.57699V7.28402H15.0114C13.6449 7.28402 13.2188 8.13195 13.2188 9.00185V11.0653H16.2695L15.7818 14.245H13.2188V21.9316C18.4775 21.1064 22.5 16.5557 22.5 11.0653Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7818 14.2461L16.2695 11.0664H13.2187V9.00298C13.2187 8.13308 13.6449 7.28515 15.0114 7.28515H16.3984V4.57812C16.3984 4.57812 15.1396 4.36328 13.9361 4.36328C11.4235 4.36328 9.78125 5.88609 9.78125 8.64297V11.0664H6.98828V14.2461H9.78125V21.9328C10.3413 22.0206 10.9153 22.0664 11.5 22.0664C12.0847 22.0664 12.6587 22.0206 13.2187 21.9328V14.2461H15.7818Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3363_10827"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(0.5 0.0664062)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.66725287.svg";
export { ForwardRef as ReactComponent };